import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    modals: [
      {
        active: false,
        type  : 'add_user',
      },
      {
        active: false,
        type  : 'add_organization',
      },
      {
        active: false,
        type  : 'accept_request',
      },
    ],
    internal_user: false,
    users_form   : {
      departments    : [],
      organizations  : [],
      roles          : [],
      specializations: [],
    },
    companies_form: {
      cities     : [],
      departments: [],
      groups     : [],
      regions    : [],
      types      : [],
      countries  : [],
    },
    chosen_region: {},
  },
  getters: {
    add_user        : ({modals}) => modals.find( (modal) => modal.type === 'add_user'),
    add_organization: ({modals}) => modals.find( (modal) => modal.type === 'add_organization'),
    accept_request  : ({modals}) => modals.find( (modal) => modal.type === 'accept_request'),
    internal_user   : ({internal_user}) => internal_user,
    chosen_region   : ({chosen_region}) => chosen_region,
    users_form      : ({users_form}) => users_form,
    companies_form  : ({companies_form}) => companies_form,
    cities_filtered : ({companies_form, chosen_region}) => {
      if (companies_form.regions.length) {
        return companies_form.cities.filter((city)=>{
          return city.region == chosen_region.id;
        });
      }
    },
  },
  mutations: {
    CLOSE_MODAL(state, dialog_type) {
      state.modals.find((modal)=> modal.type === dialog_type).active = false;
    },
    OPEN_MODAL(state, dialog_type) {
      let modal = state.modals.find((modal)=> modal.type === dialog_type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    SET_INTERNAL_USER(state, value) {
      state.internal_user = value;
    },
    SET_USERS_FORM(state, value) {
      state.users_form = value;
    },
    SET_COMPANIES_FORM(state, value) {
      state.companies_form = value;
    },
    CHOOSE_REGION(state, value) {
      state.chosen_region = value;
    },
  },
  actions: {
    async get_users_form({commit}) {
      try {
        let users_form = await api.user.get_users_form();
        let data = users_form.data;
        let hide_roles = [172, 173, 985];

        if (JSON.parse(localStorage.user).role_code !== 'ADMINISTRATOR') {
          hide_roles.forEach((id) => {
            let role_index = data.roles.findIndex((item) => parseInt(item.id) === id);
            data.roles.splice(role_index, 1);
          });
        }

        commit('SET_USERS_FORM', data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_companies_form({commit}) {
      try {
        let companies_form = await api.company.get_companies_form();
        commit('SET_COMPANIES_FORM', companies_form.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
